export const AI_EXHIBIT_BATCH6_COPY = Object.freeze({
  en: {
    askAI: {
      eyebrow: "ASK AI ABOUT AI",
      title: "What are you curious about?",
      subtitle:
        "Ask your own question about AI, or choose one of the ideas below. Answers stream live from Saras AI with museum-specific guidance.",
      openLabel: "Ask your own question",
      openHint:
        "Try AI history, how AI works, robots, jobs, creativity, safety, privacy, energy, or anything else about AI.",
      placeholder: "Type a question about AI…",
      askButton: "Ask",
      characters: "characters",
      curatedLabel: "Or try one of these",
      questions: [
        { id: "how_ai_learns", text: "How does AI learn?" },
        { id: "think_like_person", text: "Can AI think like a person?" },
        { id: "makes_things_up", text: "Why does AI sometimes make things up?" },
        { id: "understands_words", text: "Do AI systems understand meaning?" },
        { id: "consciousness", text: "Are AI systems conscious?" },
        { id: "just_autocomplete", text: "Is an LLM just autocomplete?" },
        { id: "search_difference", text: "How is AI different from internet search?" },
        { id: "jobs", text: "Could AI change people's jobs?" },
      ],
      youAsked: "You asked",
      answerLabel: "Saras AI",
      waiting: "Thinking about that…",
      choosePrompt: "Ask a question above to start.",
      another: "You can ask another question whenever you're ready.",
      errorTitle: "The AI connection did not answer.",
      errorBody:
        "The rest of this exhibit still works offline. Your question is still here—please try again in a moment.",
      phaseNote:
        "Typed questions now use the same Saras safety, session, streaming, and AI Explained pipeline as the curated questions. Voice comes later through this same path.",
    },
  },

  es: {
    askAI: {
      eyebrow: "PREGÚNTALE A LA IA SOBRE IA",
      title: "¿Qué te da curiosidad?",
      subtitle:
        "Haz tu propia pregunta sobre la IA o elige una de las ideas siguientes. Las respuestas llegan en vivo desde Saras AI con orientación especial para el museo.",
      openLabel: "Haz tu propia pregunta",
      openHint:
        "Prueba historia de la IA, cómo funciona, robots, trabajo, creatividad, seguridad, privacidad, energía o cualquier otro tema sobre IA.",
      placeholder: "Escribe una pregunta sobre la IA…",
      askButton: "Preguntar",
      characters: "caracteres",
      curatedLabel: "O prueba una de estas",
      questions: [
        { id: "how_ai_learns", text: "¿Cómo aprende la IA?" },
        { id: "think_like_person", text: "¿Puede la IA pensar como una persona?" },
        { id: "makes_things_up", text: "¿Por qué la IA a veces inventa cosas?" },
        { id: "understands_words", text: "¿Los sistemas de IA entienden el significado?" },
        { id: "consciousness", text: "¿Los sistemas de IA son conscientes?" },
        { id: "just_autocomplete", text: "¿Un LLM es solo autocompletado?" },
        { id: "search_difference", text: "¿En qué se diferencia la IA de una búsqueda en internet?" },
        { id: "jobs", text: "¿Podría la IA cambiar los trabajos de las personas?" },
      ],
      youAsked: "Preguntaste",
      answerLabel: "Saras AI",
      waiting: "Pensando en eso…",
      choosePrompt: "Haz una pregunta para comenzar.",
      another: "Puedes hacer otra pregunta cuando quieras.",
      errorTitle: "La conexión con la IA no respondió.",
      errorBody:
        "El resto de esta exhibición sigue funcionando sin conexión. Tu pregunta sigue aquí; inténtalo de nuevo en un momento.",
      phaseNote:
        "Las preguntas escritas usan ahora la misma seguridad, sesión, transmisión y contexto AI Explained que las preguntas seleccionadas. La voz llegará después por esta misma ruta.",
    },
  },
});

export function getAIExhibitBatch6Copy(language = "en") {
  return AI_EXHIBIT_BATCH6_COPY[language] || AI_EXHIBIT_BATCH6_COPY.en;
}
